<template>
  <v-app id="app">
    <menu-not-authenticated/>
    <menu-authenticated/>

    <transition name="fade">
      <router-view/>
    </transition>

    <yield-footer/>

    <v-fab-transition>
      <v-btn v-scroll="onScroll" v-show="fab"
        fab dark fixed bottom right
        color="primary" @click="toTop">
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-snackbar
      :color="snackbar.color"
      v-model="snackbar.value"
      :bottom="true"
      :timeout="snackbar.timeout">
      {{ $t(snackbar.text) }}
      <v-btn color="white" text
             @click="refreshPage()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-snackbar>

    <cookies/>
  </v-app>
</template>

<script>
  import MenuNotAuthenticated from '@/components/menu/NotAuthenticated.vue';
  import MenuAuthenticated from '@/components/menu/Authenticated.vue';
  import YieldFooter from '@/components/Footer.vue';
  import Cookies from '@/components/Cookies.vue';

  export default {
    components: {
      MenuNotAuthenticated, MenuAuthenticated, YieldFooter, Cookies
    },
    data: () => ({
      fab: false,
      snackbar: {
        value: false,
        timeout: -1,
        text: 'updated',
        color: 'success',
      },
    }),
    mounted() {
      document.addEventListener('updateApp', () => {
        this.snackbar.text = 'updated';
        this.snackbar.value = true;
      });
    },
    methods: {
      refreshPage() {
        window.location.reload();
      },
      onScroll() {
        if (typeof window === 'undefined') return;
        const top = window.pageYOffset || document.documentElement.offsetTop || 0;
        this.fab = top > 20;
      },
      toTop() {
        this.$vuetify.goTo(0);
      },
    }
  };
</script>

<style lang="scss">
  @import "assets/scss/variables";
  @import "assets/scss/layout";

  @font-face {
    font-family: 'Material Icons';
    font-style: normal;
    font-weight: 400;
    src: url('assets/fonts/Material+Icons.woff2') format('woff2');
  }

  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
  }


  .theme--light.application {
    background: transparent !important;
  }

  #app {
    font-family: 'Roboto', sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-weight: 300;
    .v-main {
      background: url('./assets/images/crossword.png');
      .container {
        @media only screen and (max-width: 3000px) and (min-width: 1000px) {
          max-width: 100% !important;
        }
      }
    }
  }
  .fade-enter-active {
    transition: opacity 1.5s;
  }
  .fade-leave-active {
    opacity: 0;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  h2 {
    width: 100%;
    text-align: left;
  }
  h1 {
    text-align: left;
    margin-bottom: 10px;
  }
  h1, h2, h3, h4, h5 {
    color: black;
    font-weight: 400;
  }

  .v-select-list {
    text-align: left;
  }

  .divider-fix {
    display: block;
    height: 1px;
    width: 100%;
    background-color: $primary;
    margin-bottom: 25px;
    margin-top: 25px;
  }

  .divider {
    display: block;
    height: 1px;
    width: 0;
    background-color: $primary;
    margin-bottom: 25px;
    animation: growLine 1s forwards;
    animation-delay: 1s;
  }
  @keyframes growLine {
    0% {
      width: 0;
    }
    100%{
      width: 100%;
    }
  }

  .v-navigation-drawer {
    .v-badge {
      width: 100%;
      text-align: left;
      .v-badge__badge {
        top: 0 !important;
        right: -5px !important;
        height: 18px !important;
        width: 18px !important;
      }
    }
  }

  .v-btn {
    text-transform: none !important;
    border-radius: 0 !important;
    &.v-btn--round {
      border-radius: 50% !important;
    }
  }
  .v-date-picker-table {
    .v-btn {
      border-radius: 50% !important;
    }
  }

  .v-card {
    .v-card__text {
      color: $primary-text !important;
    }
  }

    /*.v-menu__content {
      overflow: hidden !important;
    }*/

  .container {
    @include MQ(M) {
      max-width: 1000px !important;
    }
    @include MQ(L) {
      max-width: 1250px !important;
    }
    @include MQ(XL) {
      max-width: 1550px !important;
    }
  }

  table.v-table tbody td, table.v-table tbody th {
    height: auto !important;
  }

  body {
    overflow: hidden;
    font-family: 'Roboto', sans-serif !important;
  }
</style>
